import { M } from '@angular/cdk/keycodes';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-sinonimo-report',
  templateUrl: './sinonimo-report.component.html',
  styleUrls: ['./sinonimo-report.component.scss']
})
export class SinonimoReportComponent implements OnInit {

  datasource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['sinonimo', 'records'];
  columnsDisplayName = {
    sinonimo: 'Sinonimo',
    records: 'Quantidade'
  }

  @ViewChild('pieChartContainer', { static: false }) pieChartContainer: any;
  pieChartWidth: number = 0;
  pieChartData: any;
  submiting: boolean = false;
  constructor(
    private http: HttpService,
    private erroReport: ErrorReportService
  ) { }

  ngOnInit(): void {

    const subject = new Subject<any>();
    subject.subscribe(({ trigger, scope }: any) => {
      if (scope == 'analytics:sinonimos')
        this.submiting = trigger == 'pre';
    })
    this.http.setLoadingIndicator(subject, 'analytics:sinonimos')

  }

  getSinonimos() {

    this.http.list('analytics:sinonimos')
      .subscribe(
        (sinonimos: any) => {
          this.datasource.data = sinonimos.map((item: any) => {
            return {
              sinonimo: item.sinonimo?.trim().length == 0 ? 'Não definido' : item.sinonimo,
              records: item.records
            }
          });
          this.pieChartData = this.datasource.data
            .slice(1, 20)
            .map((item: any) => ({
              name: item.sinonimo,
              value: item.records
            }));

          setTimeout(() => {
            this.pieChartWidth = this.pieChartContainer._element.nativeElement.clientWidth - 100;
          }, 1000)

        },
        err => this.erroReport.showMessage(err)
      )

  }

}
